'use client';
import * as React from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { useRegisterMutation } from '@/app/(auth)/register/hooks/useRegisterMutation';
import Button from '@/components/buttons/Button';
import Input from '@/components/form/Input';
import UnstyledLink from '@/components/links/UnstyledLink';
import Typography from '@/components/Typography';
import { REG_EMAIL, REG_PASSWORD } from '@/constant/regex';
import { RegisterRequest } from '@/types/register';

export default function RegisterForm() {
  const [email, setEmail] = React.useState<string>('');
  //#region  //*=========== Form ===========
  const methods = useForm<RegisterRequest>({
    mode: 'onTouched',
  });
  const { handleSubmit } = methods;
  //#endregion //*======== Form ===========

  //#region  //*=========== Submit Handler ===========
  const { mutate: mutateRegister, isPending } = useRegisterMutation({
    setEmail,
  });
  const onSubmit = (data: RegisterRequest) => {
    if (!data.asal_instansi) {
      mutateRegister({
        name: data.name,
        email: data.email,
        password: data.password,
        no_telp: '+62' + data.no_telp,
      });
    } else mutateRegister(data);
  };
  //#endregion //*======== Submit Handler ===========

  return (
    <>
      <div className='mb-4 space-y-4'>
        <Typography
          as='h1'
          variant='h4'
          font='LemonMilk'
          weight='medium'
          className='text-3xl text-typo-white'
        >
          {email ? 'PERIKSA EMAIL ANDA' : 'REGISTRASI'}
        </Typography>
        {email && (
          <Typography as='p' variant='c' className='text-typo-white'>
            Anda akan menerima tautan di email yang Anda daftarkan untuk
            memverifikasi akun Anda.
          </Typography>
        )}
      </div>
      <section className='rounded-t-2xl bg-white p-5'>
        {!email ? (
          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)} className='space-y-4'>
              <Input
                id='name'
                label='Nama'
                placeholder='Masukan nama lengkap'
                validation={{
                  required: 'Nama Lengkap harus diisi',
                }}
              />
              <Input
                id='email'
                label='Email'
                placeholder='Masukan alamat email'
                validation={{
                  required: 'Email harus diisi',
                  pattern: {
                    value: REG_EMAIL,
                    message: 'Format email tidak valid',
                  },
                }}
                helperText='Format email: example@mail.com'
              />
              <Input
                id='password'
                type='password'
                label='Kata Sandi '
                placeholder='Masukan kata sandi'
                validation={{
                  required: 'Kata sandi harus diisi',
                  pattern: {
                    value: REG_PASSWORD,
                    message:
                      'Kata sandi harus mengandung minimal 8 karakter yang terdiri atas kombinasi huruf besar, huruf kecil, dan angka',
                  },
                }}
                helperText='Kata sandi harus mengandung minimal 8 karakter yang terdiri atas kombinasi huruf besar, huruf kecil, dan angka'
              />
              <Input
                id='no_telp'
                label='Nomor Telepon'
                placeholder='Masukan nomer telpon'
                validation={{
                  required: 'Nomor Telepon harus diisi',
                }}
                helperText='Contoh: 81234567890'
                prefix='+62'
              />
              <Input
                id='asal_instansi'
                label='Asal Instansi (Opsional)'
                placeholder='Masukan asal instansi'
              />

              <Button
                type='submit'
                variant='primary'
                size='lg'
                className='w-full'
                isLoading={isPending}
              >
                <Typography
                  as='p'
                  variant='btn'
                  weight='medium'
                  className='text-typo-main'
                >
                  Daftar
                </Typography>
              </Button>

              <Typography as='p' variant='c' className='text-center'>
                Sudah punya akun?{' '}
                <UnstyledLink
                  href='/login'
                  className='font-bold text-primary-info-main hover:text-primary-info-hover hover:underline'
                >
                  Login
                </UnstyledLink>
              </Typography>
            </form>
          </FormProvider>
        ) : (
          <div className='space-y-4'>
            <Typography
              as='p'
              variant='t'
              weight='semibold'
              className='text-typo-main'
            >
              {email}
            </Typography>
            <div
              className='flex h-0.5 w-full items-center justify-center bg-gradient-to-r'
              style={{
                background:
                  'linear-gradient(to right, #3BD09A 0%, #54C4DB 25%, #FC3E3E 60%, #FFCF55 100%)',
                zIndex: 0,
              }}
            />
            <Typography
              as='p'
              variant='bt'
              weight='regular'
              className='text-typo-main'
            >
              Jika Anda tidak melihat email tersebut, periksa tempat lain yang
              mungkin ada, seperti folder sampah, spam, sosial, atau lainnya.
            </Typography>
          </div>
        )}
      </section>
    </>
  );
}
